export enum Role {
	Developer = 'Developer',
	Administrator = 'Administrator',
	SuperAdmin = 'SuperAdmin'
}
